import { useTranslation } from 'react-i18next'
import { MessageCircle, CheckCircle, Ban } from 'lucide-react'

interface ChatHeaderProps {
    isDone: boolean
    isConnected: boolean
    isConnecting: boolean
    hasError: boolean
    onMarkDone: () => void
    onBlockUser: () => void
}

const ChatHeader: React.FC<ChatHeaderProps> = ({
    isDone,
    isConnected,
    isConnecting,
    hasError,
    onMarkDone,
    onBlockUser,
}) => {
    const { t } = useTranslation()

    return (
        <div className="bg-gradient-to-r from-blue-600 to-blue-500 px-4 py-3 flex items-center justify-between min-h-[64px]">
            <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
                    <MessageCircle size={20} className="text-white" />
                </div>
                <div>
                    <h3 className="font-semibold text-white">
                        {t('Messages')}
                    </h3>
                    <div className="flex items-center gap-2">
                        {isConnecting && (
                            <span className="text-xs text-blue-100 flex items-center gap-1">
                                <span className="w-1.5 h-1.5 bg-yellow-400 rounded-full animate-pulse" />
                                {t('Connecting...')}
                            </span>
                        )}
                        {isConnected && (
                            <span className="text-xs text-blue-100 flex items-center gap-1">
                                <span className="w-1.5 h-1.5 bg-green-400 rounded-full" />
                                {t('Connected')}
                            </span>
                        )}
                        {hasError && !isConnecting && !isConnected && (
                            <span className="text-xs text-red-200 flex items-center gap-1">
                                <span className="w-1.5 h-1.5 bg-red-400 rounded-full" />
                                {t('Disconnected')}
                            </span>
                        )}
                    </div>
                </div>
            </div>

            {/* Block button — always visible unless chat is done */}
            {!isDone && (
                <div className="flex gap-2">
                    <button
                        onClick={onBlockUser}
                        className="px-3 py-1.5 text-xs font-medium text-white bg-white/20 hover:bg-white/30 rounded-lg transition-colors flex items-center gap-1.5"
                    >
                        <Ban size={14} />
                        {t('Block')}
                    </button>
                    {/* Done button — commented out, replaced by "Đồng bộ Marketing" in RoomInfo */}
                    {/* <button
                        onClick={onMarkDone}
                        className="px-3 py-1.5 text-xs font-medium text-blue-600 bg-white hover:bg-blue-50 rounded-lg transition-colors flex items-center gap-1.5"
                    >
                        <CheckCircle size={14} />
                        {t('Done')}
                    </button> */}
                </div>
            )}

            {isDone && (
                <span className="px-3 py-1.5 text-xs font-medium text-white bg-green-500/80 rounded-lg flex items-center gap-1.5">
                    <CheckCircle size={14} />
                    {t('Completed')}
                </span>
            )}
        </div>
    )
}

export default ChatHeader
